<knx-badge [class]="_computedClass()">
  @if (positive()) {
    <ng-icon name="lucideChevronsUp"></ng-icon>
  }

  @if (negative()) {
    <ng-icon name="lucideChevronsDown"></ng-icon>
  }

  {{ displayValue() }}
</knx-badge>
